<template>
  <div class="bg-base d-flex flex-column">
    <!--首页header第一行-->
    <nav-header/>
    <!--主题内容显示-->
    <router-view :style="{'min-height' : clientHeight + 'px'}"/>
    <!--首页footer-->
    <nav-footer v-if="showFooter" id="footer"/>
  </div>
</template>

<script>
  import NavHeader from './IndexComps/NavHeader'
  import NavFooter from './IndexComps/NavFooter'

  export default {
    name: 'IndexWrap',
    data() {
      return {
        showFooter: true
      }
    },
    computed: {
      routerPath() {
        // return this.$route.path.split('/')[3];
        return this.$route.path;
      },
      clientHeight() {
        return document.documentElement.clientHeight - 228
      }
    },
    components: {NavHeader, NavFooter},
    mounted() {
      this.IsShowFooter();
    },
    watch: {
      'routerPath':'IsShowFooter'
    },
    methods: {
      IsShowFooter() {
         // this.showFooter = !(this.routerPath === 'hotel_list_map' || this.routerPath === 'homestay_list_map' || this.routerPath === 'scenic_list_map');
        this.showFooter = (this.routerPath.indexOf('_list_map') === -1);
      },
    }
  }
</script>
